export const RESET_ERROR_MESSAGE = 'RESET_ERROR_MESSAGE';
export const resetError = () => ({ type: RESET_ERROR_MESSAGE });
export const ADD_ERROR_MESSAGE = 'ADD_ERROR_MESSAGE';
export const addError = (err) => ({ type: ADD_ERROR_MESSAGE, err });
export const RESET_SUCCESS_MESSAGE = 'RESET_SUCCESS_MESSAGE';
export const resetSuccess = () => ({ type: RESET_SUCCESS_MESSAGE });
export const SHOW_SUCCESS_MESSAGE = 'SHOW_SUCCESS_MESSAGE';
export const showSuccess = (message) => ({ type: SHOW_SUCCESS_MESSAGE, message });
export const APP_LOADING = "APP_LOADING";
export const appLoading = () => ({ type: APP_LOADING });
export const APP_READY = "APP_READY";
export const appReady = () => ({ type: APP_READY });
